import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';
// import modalQuantityCart from '../modal-quantity-cart/modal-quantity-cart.view.html';
// import modalConfirmationCart from '../modal-confirmation/modal-confirmation.view.html';

let inject = [
    '$scope',
    '$state',
    '$rootScope',
    'SharedService',
    'ngAuthSettings',
    'CatalogService',
    '$uibModal',
    '$timeout'
];

class CarouselCategoryController {
    constructor($scope, $state, $rootScope, SharedService, ngAuthSettings, CatalogService, $uibModal, $timeout) {
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.$scope = $scope;
        this.CatalogService = CatalogService;
        this.$timeout = $timeout;
        this.ngAuthSettings = ngAuthSettings;
        this.$rootScope = $rootScope;
        this.SharedService = SharedService;
        this.productsInfo = {};
        this.featuredCategorys = {};
        this.imageData = [];
    }

    $onInit() {
            this.getBrands();
        //    this.getProcess();

    }

    getProcess() {

        let userId = '';
        try {
            userId = this.shCtrl.globals.currentUser.userId;
        }
        catch (e) {
        }

        this.CatalogService.getProducts(userId, 10, 'destacados2').then(response => {

            let val = this;
            angular.forEach(response, function (value, key) {
                val.imageData.push({
                    img: value.imagesDetail[0].path + value.imagesDetail[0].image,
                    title: value.name,
                    description: value.shortDescription,
                    link: '#'
                });
            });

            if (this.imageData.length > 0) {
                this.initBrandsCarousel();
            }

        }).catch(error => {
        });
    }

    getBrands() {
        this.CatalogService.getFeaturedCategories().then(response => {

            this.featuredCategorys = response;
            this.initBrandsCarousel();
        }).catch(error => {
        });
    }

    initBrandsCarousel() {
        this.$timeout(function () {

            let brandsItemsSlider = $('.category-slider');
            brandsItemsSlider.owlCarousel({
                items: 4,
                itemsDesktop: [1199, 3],
                itemsDesktopSmall: [979, 2],
                itemsTablet: [768, 2],
                itemsMobile: [479, 1],
                slideSpeed: 400,
                autoPlay: 8000,
                stopOnHover: true,
                navigation: false,
                pagination: false,
                responsive: true,
                mouseDrag: false,
                autoHeight: false
            }).data('navigationBtns', ["#carousel-category-slider-prev", "#carousel-category-slider-next"]);
            brandsItemsSlider.each(function () {
                let $this = $(this),
                    owlCarousel = $this.data('owlCarousel'),
                    owlBtns = $this.data('navigationBtns'),
                    prevBtn, nextBtn;

                if (typeof owlCarousel === 'undefined' || typeof owlBtns === 'undefined') {
                    return;
                }

                for (let key in owlBtns) {
                    if (owlBtns[key].indexOf('next') === -1) {
                        prevBtn = $(owlBtns[key]);
                    } else {
                        nextBtn = $(owlBtns[key]);
                    }
                }

                prevBtn.on('click touchstart', function (e) {
                    owlCarousel.prev();
                    e.preventDefault();
                });

                nextBtn.on('click touchstart', function (e) {
                    owlCarousel.next();
                    e.preventDefault();
                });
            });

            $('.add-tooltip').tooltip();
        }, 1000);
    }

    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }

}

CarouselCategoryController.$inject = inject;

export default CarouselCategoryController;




/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/home/carousel-category/carousel-category.controller.js
 **/